import styled from '@mui/material/styles/styled';

export const LogoButton = styled('a')(() => ({
  padding: 0,
  cursor: 'pointer',
  border: 'none',
  backgroundColor: 'transparent',
}));

/**
 * Co-branded Wellhub × Urban Sports Club lockup.
 *
 * The `<source>` swaps the wide desktop lockup in at the `md` breakpoint; the
 * `<img>` keeps `width: auto` so each resource renders at its own aspect ratio.
 * The stacked mobile combo (161×50) is capped at 36px — a mid-point between
 * the legacy 24px header logo and the asset's native 50px — while the
 * single-line desktop lockup (274×24) keeps the original 24px header height.
 */
export const CoBrandPicture = styled('picture')(({ theme }) => ({
  display: 'inline-flex',
  verticalAlign: 'middle',

  '& > img': {
    height: 36,
    width: 'auto',

    [theme.breakpoints.up('md')]: {
      height: 24,
    },
  },
}));

export const Image = styled('img')`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;
